import { readableInteractionState } from '@/config';

export default ineractionState =>
  readableInteractionState[ineractionState] || 'Onbekend';
